import { useEffect, useState } from 'react'

import useTranslation from 'next-translate/useTranslation'

import { REDIRECT_TIMEOUT } from '@/modules/trials/constants'

import { redirectToSamlLogin } from '@/utils/saml/redirectToSamlLogin'

import { TrialLoadingIcon } from '../TrialLoadingIcon'
import { useTrial } from '../TrialProvider'

export function TrialExistingAccount() {
	const { email } = useTrial()
	const { t } = useTranslation('trials')

	const [timeLeft, setTimeLeft] = useState(REDIRECT_TIMEOUT / 1000)

	useEffect(() => {
		if (!timeLeft) {
			redirectToSamlLogin(email)

			return
		}

		const interval = setInterval(() => {
			setTimeLeft((time) => time - 1)
		}, 1000)

		return () => clearInterval(interval)
	}, [timeLeft, email])

	return (
		<div className="text-center text-bc-black pt-8 lg:pt-12">
			<TrialLoadingIcon />
			<h2 className="text-2xl font-medium">{t('trialForm.status.existingAccount.headline')}</h2>
			<p className="py-6">{t('trialForm.status.existingAccount.body')}</p>
			<button
				type="button"
				onClick={() => redirectToSamlLogin(email)}
				className="border-2 py-2 px-6 rounded-md border-bc-black text-bc-black w-auto font-medium text-xs"
			>
				{t('trialForm.status.existingAccount.buttons.redirect')}
			</button>
		</div>
	)
}
